// extracted by mini-css-extract-plugin
module.exports = {"a":"MintOG_a__2y0c7","h2":"MintOG_h2__3L4Rp"};